import React from 'react';
import { Layout } from 'react-admin';
import Menu from '../menu';
import AppBar from '../../components/appbar';

const MyLayout = props => <Layout {...props} menu={Menu} appBar={AppBar} style={{ marginTop: 30 }}/>;

export default MyLayout;
